import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { EstadosPreFacturacion, CodigosTransaccionesConstant } from 'constants/index'

import { ZrSwal } from 'utils'

import * as PreFacturacionService from 'services/preFacturacion.service'

const portletBreadcrumbs = [{ name: 'Pre-Ventas' }]

const tableHeaderRows = [
  {
    label: 'IDENTIFICADOR',
    align: 'center',
    filter: {
      type: 'text',
      name: 'identificador'
    }
  },
  {
    label: 'NOMBRE',
    align: 'center',
    filter: {
      type: 'text',
      name: 'nombre'
    }
  },
  {
    label: 'FECHA',
    align: 'center'
  },
  {
    label: 'HORA',
    align: 'center'
  },
  {
    label: 'ESTADO',
    align: 'center'
  },
  {
    label: 'USUARIO',
    align: 'center'
  },
  { label: '', align: 'center' }
]

const ListaVentasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.PREFACTURACIONES_NUEVOACTUALIZAR}`)
  }, [history])

  const clickEditar = React.useCallback(
    id => {
      history.push(`/${CodigosTransaccionesConstant.PREFACTURACIONES_NUEVOACTUALIZAR}/${id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        mensaje: 'Seguro de eliminar el registro?',
        tipo: 'error',
        showCerrar: true,
        onSuccess: () => {
          PreFacturacionService.eliminarxId(id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Pre-Ventas'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useFilters={true}
            useNest={true}
            url='/pre-facturaciones'
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.identificador || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.nombre || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.horaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.estado ? EstadosPreFacturacion.__dictionary[row.estado].nombre : '--'}
                </Table.Cell>
                <Table.Cell align='center'>{row.usuario || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={() => clickEditar(row._id)}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={() => clickEliminar(row._id)}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ListaVentasPage
